import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/assets/cms_templates_repo/templates.json'

Vue.use(VueI18n)
// let messages = {}
// const test = Object.assign({}, messages, templateData)
// messages = test
const i18n = new VueI18n({
	locale: 'en', // set locale
	fallbackLocale: 'es', // set fallback locale
	messages // set locale messages
})

export default i18n
